import { Directive, input } from '@angular/core'

/**
 * Zeigt einen Spinner auf einem `<mat-icon>`, solange geladen wird:
 *
 * ```html
 * <mat-icon [libLoading]="saving()">save</mat-icon>
 * ```
 *
 * Der Icon-Name im Template bleibt dabei unangetastet — der Spinner wird als Pseudo-Element
 * darübergelegt (`.mat-icon.lib-loading` in `basic.scss`). Eine frühere Fassung hat stattdessen
 * `textContent` gesetzt und den Namen dafür in `ngOnInit` zwischengespeichert; bei einem
 * **interpolierten** Icon (`{{ icon() }}`) war der Cache zu diesem Zeitpunkt noch leer, und das
 * Icon blieb danach dauerhaft unsichtbar.
 */
@Directive({
  selector: 'mat-icon[libLoading]',
  host: {
    '[class.lib-loading]': 'loading()',
    '[class.spin]': 'loading()',
  },
})
export class IconLoadingDirective {
  readonly loading = input(false, { alias: 'libLoading' })
}
